import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-word-template-preview',
    templateUrl: './word-template-preview.component.html',
    styleUrl: './word-template-preview.component.scss',
    standalone: false,
})
export class WordTemplatePreviewComponent {
    constructor(
        public dialogRef: MatDialogRef<WordTemplatePreviewComponent>,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            url: string;
            height: number;
        },
    ) {}
}
